import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AccessDenied from './components/AccessDenied';
import {
  getToken,
  getUsername,
  hasSuperAdminRole,
  initAuth,
  isAuthConfigured,
  logout,
} from './auth/keycloak';
import { installAuthFetch } from './auth/authFetch';
import './index.css';
import './styles/components.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function renderApp(): void {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

function renderAuthError(error: unknown): void {
  console.error('Keycloak initialization failed:', error);
  root.render(
    <div style={{ padding: 40, fontFamily: 'sans-serif', textAlign: 'center' }}>
      <h1>Authentication unavailable</h1>
      <p>Could not reach the login service. Please try again.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Retry
      </button>
    </div>
  );
}

async function bootstrap(): Promise<void> {
  if (!isAuthConfigured()) {
    // Local development without Keycloak (pair with backend
    // AI_TOOLS_AUTH_ENABLED=false). Deployed builds always bake the
    // REACT_APP_KEYCLOAK_* vars in at image build time.
    console.warn(
      '[auth] REACT_APP_KEYCLOAK_* not configured — running without authentication (local dev only).'
    );
    renderApp();
    return;
  }

  try {
    const { authenticated } = await initAuth();
    if (!authenticated) {
      // login-required redirects to Keycloak; nothing to render.
      return;
    }

    installAuthFetch(getToken);

    if (!hasSuperAdminRole()) {
      root.render(
        <React.StrictMode>
          <AccessDenied username={getUsername()} onLogout={logout} />
        </React.StrictMode>
      );
      return;
    }

    renderApp();
  } catch (error) {
    renderAuthError(error);
  }
}

bootstrap();